// modules
import { createSelector } from 'reselect'

const patientGamification = (state) => state.patient.gamification

export const patientWallet$ = createSelector(
  patientGamification,
  (patientGamification) => patientGamification.wallet
)

export const patientWalletHistory$ = createSelector(
  patientGamification,
  (patientGamification) => patientGamification.walletHistory
)

export const patientTasks$ = createSelector(
  patientGamification,
  (patientGamification) => patientGamification.tasks
)

export const patientAchievements$ = createSelector(
  patientGamification,
  (patientGamification) => patientGamification.achievements
)

export const patientMedal$ = createSelector(
  patientGamification,
  (patientGamification) => patientGamification.medal
)

export const patientGamificationLoading$ = (loader) =>
  createSelector(
    patientGamification,
    (patientGamification) => patientGamification.loaders[loader]
  )

export const patientGamificationCompliance$ = createSelector(
  patientGamification,
  (patientGamification) => patientGamification.compliance
)

export const patientGamificationActivities$ = createSelector(
  patientGamification,
  ({ gamificationActivities }) => gamificationActivities
)

export const patientGamificationActivitiesLoading$ = createSelector(
  patientGamification,
  ({ loading }) => loading
)

export const gamificationModules$ = createSelector(
  patientGamification,
  ({ gamificationModules }) => gamificationModules
)

export const gamificationAchievements$ = createSelector(
  patientGamification,
  ({ gamificationAchievements }) => gamificationAchievements
)

export const medicationCompliance$ = createSelector(
  patientGamification,
  ({ medicationCompliance }) => medicationCompliance
)
